import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../components/Hyperlink';
import styles from './footer_social.module.scss';

export const FooterSocial: FC = () => (
  <>
    <Hyperlink className={styles.logo} href="/" source="footer_static_logo">
      <span className={styles.img} />
      <span className={styles.title}>
        <FormattedMessage id="footer/components/social/FooterSocial.tsx/1" />
      </span>
    </Hyperlink>
    <div className={styles.tagline}>
      <FormattedMessage id="footer/components/social/FooterSocial.tsx/2" />
    </div>
    <div className={styles.socialContainer}>
      <Hyperlink
        className={styles.social}
        href="https://www.linkedin.com/company/doctrine"
        target="_blank"
        rel="noopener noreferrer"
        data-snapshot="keep"
      >
        <img
          className={styles.icon}
          src="/img/logo/social/linkedin_clear.png"
          alt="linkedin"
        />
      </Hyperlink>
      <Hyperlink
        className={styles.social}
        href="https://twitter.com/doctrine"
        target="_blank"
        rel="noopener noreferrer"
        data-snapshot="keep"
      >
        <img
          className={styles.icon}
          src="/img/logo/social/twitter_clear.png"
          alt="twitter"
        />
      </Hyperlink>
      <Hyperlink
        className={styles.social}
        href="https://www.facebook.com/doctrineFR/"
        target="_blank"
        rel="noopener noreferrer"
        data-snapshot="keep"
      >
        <img
          className={styles.icon}
          src="/img/logo/social/facebook_clear.png"
          alt="facebook"
        />
      </Hyperlink>
      <Hyperlink
        className={styles.social}
        href="https://www.youtube.com/c/DoctrineFr"
        target="_blank"
        rel="noopener noreferrer"
        data-snapshot="keep"
      >
        <img
          className={styles.icon}
          src="/img/logo/social/youtube.png"
          alt="youtube"
        />
      </Hyperlink>
    </div>
  </>
);
